
 // Adjust the path according to your project structure

import React, { useEffect, useState } from "react";
import bannerImage from "../img/aaaservices/mechi.webp"; 

const Banner = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <>
      <style>{`
        .banner-container {
          position: relative;
          width: 100%;
          height: 50vh;
          max-height: 50vh;

          /* 🔥 Background fixed */
          background-image:
            linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.75)),
            url(${bannerImage});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-attachment: fixed;

          overflow: hidden;
        }

        .banner-text {
          position: absolute;
          bottom: 20%;
          left: 5%;
          color: white;
          z-index: 2;
          opacity: 0;
          transform: translateY(50px);
          transition: all 1s ease-out;
          max-width: 700px;
        }

        .banner-text.animate {
          opacity: 1;
          transform: translateY(0);
        }

        .banner-heading {
          font-size: 38px;
          font-weight: bold;
          margin: 0;
        }

        .banner-heading span:last-child {
          color: gold;
        }

        .banner-subheading {
          font-size: 1.125rem;
          margin-top: 15px;
          line-height: 1.6;
          text-align: left; 
          max-width: 600px;
        }

        @media (max-width: 768px) {
          .banner-container {
            background-attachment: scroll; /* mobile fix */
          }

          .banner-heading {
            font-size: 2rem;
          }
        }
      `}</style>

      <div className="banner-container">
        <div className={`banner-text ${animate ? "animate" : ""}`}>
          <h1 className="banner-heading">
            <span>Who We </span><span>Are</span>
          </h1>

          <p className="banner-subheading">
            Engineering modern business to improve everyone’s lives.
            Let’s discover new ways of operating so you can anticipate
            and act with the latest technologies.
          </p>
        </div>
      </div>
    </>
  );
};

export default Banner;
